var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.go_top>800)?_c('div',{staticClass:"gotops",on:{"click":_vm.go_tops}},[_c('img',{attrs:{"src":require("@/assets/backtop.png"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('headerComponent'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('footerComponent')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1ccb782","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 